import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";

const styles = createUseStyles(theme => ({
  breadcrumbs:{
    margin: "0 0 20px 0",

    "& a": {
      textDecoration: "none",
      color: colors.mediumGrey,
    }
  },
  breadItem: {
    color: colors.mediumGrey,
    fontSize: "14px",
    fontWeight: "500",
    fontStyle: "normal",
    fontFamily: "Inter"
  },
  chevron: {
    margin: "0 8px",
    height: "16px",
    width: "16px",
    "& path": {
      stroke: colors.darkGrey,
    }
  },
  lastItem: {
    padding: "4px 8px",
    backgroundColor: colors.brightBlue,
    color: colors.grey,
    borderRadius: "6px",
    fontWeight: "600"
  }
}));

export default styles;
